// Copyright (c) Microsoft. All rights reserved.

import { Plugin } from '../../redux/features/plugins/PluginsState';
import { PluginManifest } from '../models/PluginManifest';
import { BaseService } from './BaseService';

export class PluginService extends BaseService {
    public getPluginManifestAsync = async (manifestDomain: string, accessToken: string, UserMode: string | undefined): Promise<PluginManifest> => {
        return await this.getResponseAsync<PluginManifest>(
            {
                commandPath: 'pluginManifests',
                method: 'GET',
                query: new URLSearchParams({
                    manifestDomain: manifestDomain,
                }),
            },
            accessToken,
            UserMode
        );
    };

    public getConnectPluginsAsync = async (accessToken: string, UserMode: string | undefined): Promise<Plugin[]> => {
        return await this.getResponseAsync<Plugin[]>(
            {
                commandPath: 'plugins',
                method: 'GET',
            },
            accessToken,
            UserMode
        );
    };

    public pluginStatusUpdateAsync = async (pluginName: string, enabled: boolean, accessToken: string, UserMode: string | undefined): Promise<Plugin> => {
        return await this.getResponseAsync<Plugin>(
            {
                commandPath: `plugin/status-update/${pluginName}/${enabled}`,
                method: 'PUT',
            },
            accessToken,
            UserMode
        );
    };

    public setPluginStateAsync = async (
        chatId: string,
        pluginName: string,
        accessToken: string,
        UserMode: string | undefined,
        enabled: boolean,
    ): Promise<void> => {
        await this.getResponseAsync(
            {
                commandPath: `chats/${chatId}/plugins/${pluginName}/${enabled}`,
                method: 'PUT',
            },
            accessToken,
            UserMode
        );
    };
}
